import repositoryService from '../../services/RepositoryService';
import appConfig from '../../services/AppConfigService';
import localDatabase from '../../services/LocalDatabaseService';

const PATH = appConfig.apiUrl() + '/f/ba';

const state = {
  list: []
}

export const mutationsTypes = {
  LIST: 'modules/LIST',
  PAGINATION: 'modules/PAGINATION',
  UPDATE_FILTER: 'modules/UPDATE_FILTER',
  UPDATE_FILTER_CURRENT_PAGE: 'modules/UPDATE_FILTER_CURRENT_PAGE',
  UPDATE_FILTER_ITEMS_PER_PAGE: 'modules/UPDATE_FILTER_ITEMS_PER_PAGE'
}

/* eslint-disable no-param-reassign */
const mutations = {
  [mutationsTypes.LIST] (state, payload) {
    state.list = payload
  },

  [mutationsTypes.PAGINATION] (state, payload) {
    state.pagination = payload
  },

  [mutationsTypes.UPDATE_FILTER] (state, payload) {
    state.filter = Object.assign({}, state.filter, payload)
  },

  [mutationsTypes.UPDATE_FILTER_CURRENT_PAGE] (state, payload) {
    state.filter.currentPage = payload
  },

  [mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE] (state, payload) {
    state.filter.itemsPerPage = payload
  }
}

const actions = {

  modulesSetList: ({commit}, payload) => {
    commit(mutationsTypes.LIST, payload)
  },

  modulesSetPagination: ({commit}, payload) => {
    commit(mutationsTypes.PAGINATION, payload)
  },

  modulesSetItemsPerPage({dispatch, commit}, payload) {
    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, 1)
    commit(mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, payload)
    dispatch("modulesSearch")
  },

  modulesSetPage({dispatch, commit}, payload) {
    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, payload)
    dispatch('modulesSearch')
  },

  modulesDoSearch({dispatch }, payload) {
    dispatch("modulesSearch", payload)
  },

  modulesSearch({dispatch}, payload) {
    dispatch("showLoader");

    let url = PATH;

    let businessAreaId = payload.businessAreaId;
    let systemId = payload.systemId;
    let systemVersion = payload.systemVersion;

    url = url + "/" + businessAreaId + "/c/" + systemId + "/" + systemVersion + "/ms"

    repositoryService.search(url)
      .then(response => {
        dispatch('modulesSetList', response)
        dispatch('hideLoader')
      })
  },

  modulesSave({}, payload) {
    return repositoryService.save(PATH, payload, true)
  },

  modulesGetInstance({}, payload) {
    return localDatabase.findById('Modules_' + payload)
  }
}

const getters = {
  modulesFilter: function (state) {
    return Object.assign({}, state.filter)
  },
  modulesList: function () {
    return state.list
  },
  modulesPagination: function () {
    return state.pagination
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/app/modules/ModulesVuex.js